// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ms70r","left":"styles_left__3VX--","desktopActions":"styles_desktopActions__2k0cx","title":"styles_title__3zMtf"};